import { useTranslation } from 'react-i18next';

interface NumOfBlocksProps {
  current: number;
  max: number;
}

export const NumOfBlocks = ({ current, max }: NumOfBlocksProps) => {
  const { t } = useTranslation('crm');

  return (
    <span className="text-gray-5 text-2xs">
      {t('crm.sortableBlocks.numOfBlocks', {
        current: current,
        max: max,
      })}
    </span>
  );
};
